class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      viewer: this.querySelector('[id^="GalleryViewer"]'),
      media: this.querySelectorAll('[data-media-id]'),
    };
  }

  connectedCallback() {
    this.setActiveMedia(this.elements.media[0].dataset.mediaId, false);

    document.querySelectorAll('variant-selects, variant-radios').forEach((variantEl) => {
      variantEl.addEventListener('change', (event) => {
        const variant = event.target.closest('variant-selects, variant-radios').currentVariant;
        if (!variant || !variant.featured_media) return;

        this.setActiveMedia(`${this.dataset.section}-${variant.featured_media.id}`);
      });
    });
  }

  setActiveMedia(mediaId, prepend = true) {
    const activeSlide = this.querySelector(`[data-media-id="${mediaId}"]`);
    if (!activeSlide) return;

    const slider = this.elements.viewer;
    const scrollLeft = activeSlide.offsetLeft - slider.offsetLeft;

    slider.scrollTo({ left: scrollLeft, behavior: 'smooth' });

    this.elements.media.forEach((media) => {
      media.classList.remove('is-active');
    });
    activeSlide.classList.add('is-active');

    const thumbnail = this.querySelector(`[data-target="${mediaId}"]`);
    if (!thumbnail) return;

    this.querySelectorAll('.thumbnail').forEach((element) =>
      element.removeAttribute('aria-current')
    );
    thumbnail.querySelector('.thumbnail').setAttribute('aria-current', true);
  }
}

customElements.define('media-gallery', MediaGallery);
